import React, { useEffect, useState } from 'react';
import { FactorSelectionForm, VerifyPasscodeForm } from 'forms';
import { useApi } from 'hooks';
import { verifyOwnership, statefulSendFactor, statefulVerifyPasscode } from 'api';
import { Process } from 'common';
import ErrorPage from 'pages/errorPage';

const VerifyLoanOwnershipPage = ({ accessToken, loanId, onContinue }) => {
  const [stateToken, setStateToken] = useState();
  const [factors, setFactors] = useState();
  const [selectedFactor, setSelectedFactor] = useState();
  const [action, setAction] = useState();
  const [displayHelp, setDisplayHelp] = useState();

  const [verifyOwnershipStatus, callVerifyOwnership] = useApi(verifyOwnership);
  const [statefulSendFactorStatus, callStatefulSendFactor] = useApi(statefulSendFactor);
  const [statefulVerifyPasscodeStatus, callStatefulVerifyPasscode] = useApi(statefulVerifyPasscode);

  useEffect(() => {
    const initialize = async () => {
      const data = await callVerifyOwnership(accessToken, loanId);
      if (!data) {
        setDisplayHelp(true);
        return;
      }

      if (data.status === 'MFA_REQUIRED') {
        setStateToken(data.stateToken);
        setFactors(data.factor);
        setAction('SEND_OTP');
      } else onContinue();
    };

    initialize();
    // eslint-disable-next-line
  }, []);

  const send = async (factor) => {
    const response = await callStatefulSendFactor(accessToken, stateToken, factor);
    if (!response) return;

    setSelectedFactor(factor);
    setAction('VERIFY_OTP');
  };

  const verify = async (passcode) => {
    const response = await callStatefulVerifyPasscode(accessToken, stateToken, selectedFactor, passcode);
    if (!response) return;

    onContinue();
  };

  const PAGES = {
    SEND_OTP: <FactorSelectionForm factors={factors} send={send} />,
    VERIFY_OTP: (
      <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
    ),
  };

  const isLoading = () =>
    verifyOwnershipStatus.isLoading || statefulSendFactorStatus.isLoading || statefulVerifyPasscodeStatus.isLoading;

  const error = () => {
    let tempError = false;
    if (verifyOwnershipStatus.error) tempError = verifyOwnershipStatus.error;
    if (statefulSendFactorStatus.error) tempError = statefulSendFactorStatus.error;
    if (statefulVerifyPasscodeStatus.error) tempError = statefulVerifyPasscodeStatus.error;
    return tempError;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      {console.log('action', action)}
      {displayHelp ? <ErrorPage /> : PAGES[action]}
    </Process>
  );
};

export default VerifyLoanOwnershipPage;
